import { useWorkspace } from 'hooks/useWorkspace';
import React from 'react';

import InAppNotificationStack from './InAppNotificationStack';
import { useInAppNotificationStack } from './useInAppNotificationStack';

/**
 * Displays stack of notifications from GraphQL `notificationPublished`
 * Front card auto-dismisses after 10s; dismiss calls `readNotification`
 * NOTE: Client-side toasts use `MessagesDisplay` only
 */
const InAppNotifications: React.FC = () => {
  const { workspace } = useWorkspace();
  const { visibleItems, dismissItem, navigateTo, pathname } = useInAppNotificationStack({
    accountId: workspace.operatorId,
  });

  return (
    <InAppNotificationStack
      items={visibleItems}
      pathname={pathname}
      onDismiss={dismissItem}
      onNavigate={navigateTo}
    />
  );
};

export default InAppNotifications;
